<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_badge' | translate: lang }}</h5>
  <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">

  <h5 class="text-center modal-p">{{ 'popular_badges' | translate: lang }}</h5>
  <div class="row">
    <ng-container *ngFor="let popularBadge of Badges['apex'];let i = index;">
      <div *ngIf="popularBadge.popular"  class="col-md text-center">
        <img class="badge-img" (click)="onSelect(i)" title="{{popularBadge.description}}" src="{{'https://cdn.ggboost.com/images/badges/apex/'+i+'.webp' | cdn}}" alt="">
        <div  class="rank-select-item" (click)="onSelect(i)">{{divisionService.getBadgeTitle(i,'apex')}}</div>
      </div>
    </ng-container>
  </div>
  <div class="line"></div>
  <h5 class="text-center modal-p" style="margin-top:1rem;">{{ 'all_badges' | translate: lang }}</h5>

  <div class="row">
    <ng-container *ngFor="let badge of Badges['apex']; let i = index">
      <div *ngIf="i < 36 && ![0, 4, 5, 8, 22].includes(i) && !Badges['apexRemovedBadgesIds'].includes(i)" class="col-md text-center apex-badges">
        <img
          (click)="onSelect(i)"
          style="cursor:pointer;"
          height="140"
          src="{{'https://cdn.ggboost.com/images/badges/apex/' + i + '.webp' | cdn}}"
          alt="{{badge.title}}"
          title="{{badge.description}}"
        >
        <div class="rank-select-item" (click)="onSelect(i)">{{badge.title}}</div>
      </div>
    </ng-container>
  </div>

</div>